import ReportEditConfigController from './ATReportEditConfigController'
import ThreeLevelReportGroupingSelector from '../ThreeLevelReportGroupingSelector'
import {ReportGroupingLevel} from '../constants'
import ChooseTypeSelector from '../../controls/invoice_billing_summary_choose_type'

export default class InvoiceReportEditConfigController extends ReportEditConfigController{}

InvoiceReportEditConfigController.prototype.init = function ( config )
{
    ReportEditConfigController.prototype.init.call(this, config);

    this.configChangedCallback = config.changeCallback;
    const configChanged = () => this.configChanged()
    this.reportAuthorizationInfo = config.reportAuthorizationInfo
    const reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters)
    this.groupingSelector = new ThreeLevelReportGroupingSelector().init({
            selectorId: "reportGroupingSelector",
            enableNoneFirstGrouping: true,
            enableGroupByBillingType: false,
            enableGroupByUsers: true,
            enableGroupByUserGroups: EnabledFeatures.UGR
                                     || reportParameters.firstGroupingLevel === ReportGroupingLevel.USER_GROUP
                                     || reportParameters.secondGroupingLevel === ReportGroupingLevel.USER_GROUP,
            includeTTCommentsInDetailsLevel: true,
            groupingLevelsSelection: [
                reportParameters.firstGroupingLevel,
                reportParameters.secondGroupingLevel,
                reportParameters.thirdGroupingLevel
            ],
            changesCallback: () => {
                this.removeGroupingLevelsSelectionError()
                configChanged()
            }
        }
    )
    this.cpSelector = this.makeCPSelector(reportParameters.customersProjectsSelection);
    
    this.chooseTypeSelector = new ChooseTypeSelector().init(reportParameters.reportType, configChanged);

    return this;
};

InvoiceReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    ReportEditConfigController.prototype.setSelectorsInitStateFromCurrent.call(this);

    if(this.cpSelector) {
        this.cpSelector.setInitialValueFromCurrent();
    }
};

InvoiceReportEditConfigController.prototype.getConfig = function () {
    const groupingLevelValues = this.groupingSelector.getValues()
    return {
        reportType: this.chooseTypeSelector.getValue(),
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1],
        thirdGroupingLevel: groupingLevelValues[2],
        reportAuthorizationInfo: this.reportAuthorizationInfo,
    };
};

InvoiceReportEditConfigController.prototype.resetConfig = function () {
    this.chooseTypeSelector.setValue(this.initReportParameters.reportType);
    this.cpSelector.setSelection(this.initReportParameters.customersProjectsSelection);
    this.groupingSelector.setValues([this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel, this.initReportParameters.thirdGroupingLevel]);
};

InvoiceReportEditConfigController.prototype.validate = function()
{
    this.errors = [];

    if (!this.cpSelector.checkSelected())
        this.errors.push( this.possibleErrors.ERROR_EMPTY_CP_SELECTION );

    if (!this.groupingSelector.validate())
        this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length == 0;
};

InvoiceReportEditConfigController.prototype.initErrorsToSectionElsMap = function()
{
    var errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_CP_SELECTION] = this.panelEl.find( "#cpSelectorId" );
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find( ".reportGroupingSelectorContainer" );
    return errorsToSectionElsMap;
};



// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/InvoiceReportEditConfigController.js